import { Component, Input } from '@angular/core';
import { BaseButtonComponent } from '../base-button';
import { Action, ActionType } from '../../../models/action';

@Component({
  selector: 'app-visualize-image-button',
  templateUrl: './visualize-image-button.component.html',
  styleUrls: ['./visualize-image-button.component.scss'],
})
export class VisualizeImageButtonComponent extends BaseButtonComponent {
  @Input()
  callback: () => void;

  ngOnInit() {}

  visualizeImage() {
    const action: Action = {
      type: ActionType.NONE,
      recordId: this.record.id,
    };
    this.doAction(() => this.callback(), action, false);
  }
}
